import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import { Footer } from "@/components/Footer";

const Regulamin = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Regulamin serwisu - WystepKomediowy.pl</title>
        <meta name="description" content="Regulamin serwisu WystepKomediowy.pl. Zasady korzystania z serwisu internetowego." />
        <link rel="canonical" href="https://wystepkomediowy.pl/regulamin" />
        <meta property="og:title" content="Regulamin serwisu - WystepKomediowy.pl" />
        <meta property="og:description" content="Regulamin serwisu WystepKomediowy.pl." />
        <meta property="og:url" content="https://wystepkomediowy.pl/regulamin" />
      </Helmet>
      <Navigation />
      <main className="pt-32 pb-20">
        <div className="container max-w-3xl mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-montserrat font-bold text-primary mb-8">
            Regulamin <span className="gradient-text">serwisu</span>
          </h1>

          <div className="prose prose-gray max-w-none space-y-6 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">1. Postanowienia ogólne</h2>
              <p>Niniejszy Regulamin określa zasady korzystania z serwisu internetowego WystepKomediowy.pl, którego właścicielem jest Wirtualny Biznes, ul. Księcia Witolda 49/15, 50-202 Wrocław, NIP: 8961619199.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">2. Definicje</h2>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li><strong>Serwis</strong> - strona internetowa dostępna pod adresem WystepKomediowy.pl</li>
                <li><strong>Użytkownik</strong> - każda osoba korzystająca z Serwisu</li>
                <li><strong>Usługodawca</strong> - Wirtualny Biznes, ul. Księcia Witolda 49/15, 50-202 Wrocław</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">3. Zakres usług</h2>
              <p>Serwis umożliwia:</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Zapoznanie się z ofertą występów komediowych</li>
                <li>Przesłanie zapytania ofertowego za pośrednictwem formularza kontaktowego</li>
                <li>Kontakt telefoniczny i mailowy z Usługodawcą</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">4. Warunki korzystania z Serwisu</h2>
              <p>Korzystanie z Serwisu jest bezpłatne i nie wymaga rejestracji. Użytkownik zobowiązuje się do korzystania z Serwisu zgodnie z obowiązującym prawem, dobrymi obyczajami oraz postanowieniami niniejszego Regulaminu.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">5. Realizacja usług</h2>
              <p>Szczegółowe warunki realizacji występów komediowych, w tym termin, miejsce, zakres programu oraz wynagrodzenie, ustalane są indywidualnie z każdym klientem na podstawie przesłanego zapytania.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">6. Odpowiedzialność</h2>
              <p>Usługodawca dokłada wszelkich starań, aby informacje zamieszczone w Serwisie były aktualne i rzetelne. Usługodawca nie ponosi odpowiedzialności za przerwy w dostępie do Serwisu wynikające z przyczyn technicznych.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">7. Własność intelektualna</h2>
              <p>Wszystkie treści zamieszczone w Serwisie, w tym teksty, grafiki, zdjęcia i logotypy, stanowią własność Usługodawcy i są chronione prawem autorskim. Kopiowanie, rozpowszechnianie lub wykorzystywanie tych treści bez zgody Usługodawcy jest zabronione.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">8. Reklamacje</h2>
              <p>Reklamacje dotyczące działania Serwisu można zgłaszać na adres e-mail: <a href="mailto:kontakt@wystepkomediowy.pl" className="text-brand-purple hover:underline">kontakt@wystepkomediowy.pl</a>. Reklamacje będą rozpatrywane w terminie 14 dni roboczych od daty ich otrzymania.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">9. Postanowienia końcowe</h2>
              <p>Usługodawca zastrzega sobie prawo do zmiany Regulaminu. Aktualna wersja Regulaminu jest zawsze dostępna na stronie Serwisu. W sprawach nieuregulowanych niniejszym Regulaminem zastosowanie mają przepisy prawa polskiego.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Regulamin;
